import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import FabricAttributeTooltip from './FabricAttributeTooltip';
import cleaningCodeDescriptions from './cleaning-code-desc.json';
import FabricAdditionalAttributesTag from './FabricAdditionalAttributesTag';
const FabricAdditionalAttributes = t0 => {
  const $ = _c(27);
  const {
    selectedItemGroupMaterial: t1,
    selectedItemGroupCleaningCode: t2,
    isPetAndKidFriendly: t3,
    isSustainable: t4,
    selectedItemTier: t5,
    showCleaningToolTip: t6,
    isPantoneFabric: t7,
    materialComposition: t8
  } = t0;
  const selectedItemGroupMaterial = t1 === undefined ? "" : t1;
  const selectedItemGroupCleaningCode = t2 === undefined ? "" : t2;
  const isPetAndKidFriendly = t3 === undefined ? false : t3;
  const isSustainable = t4 === undefined ? false : t4;
  const selectedItemTier = t5 === undefined ? "" : t5;
  const showCleaningToolTip = t6 === undefined ? true : t6;
  const isPantoneFabric = t7 === undefined ? false : t7;
  const materialComposition = t8 === undefined ? "" : t8;
  const cleaningCodeRef = useRef(null);
  let t9;
  try {
    let t10;
    if ($[0] !== selectedItemGroupMaterial) {
      t10 = JSON.parse(selectedItemGroupMaterial);
      $[0] = selectedItemGroupMaterial;
      $[1] = t10;
    } else {
      t10 = $[1];
    }
    t9 = t10;
  } catch {
    t9 = selectedItemGroupMaterial;
  }
  const materialGroupAttributes = t9;
  let t10;
  if ($[2] !== materialGroupAttributes) {
    t10 = Array.isArray(materialGroupAttributes) ? materialGroupAttributes : [materialGroupAttributes];
    $[2] = materialGroupAttributes;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const materialGroupAttributesArray = t10;
  let t11;
  if ($[4] !== isPetAndKidFriendly) {
    t11 = isPetAndKidFriendly ? <FabricAdditionalAttributesTag>Pet-Friendly</FabricAdditionalAttributesTag> : null;
    $[4] = isPetAndKidFriendly;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  let t12;
  if ($[6] !== isSustainable) {
    t12 = isSustainable ? <FabricAdditionalAttributesTag>Sustainable</FabricAdditionalAttributesTag> : null;
    $[6] = isSustainable;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  let t13;
  if ($[8] !== isPantoneFabric) {
    t13 = !!isPantoneFabric && <FabricAdditionalAttributesTag>Pantone</FabricAdditionalAttributesTag>;
    $[8] = isPantoneFabric;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== materialGroupAttributesArray) {
    t14 = materialGroupAttributesArray.filter(_temp).map(_temp2);
    $[10] = materialGroupAttributesArray;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== selectedItemTier) {
    t15 = selectedItemTier ? <FabricAdditionalAttributesTag>{`Tier ${selectedItemTier}  `}</FabricAdditionalAttributesTag> : null;
    $[12] = selectedItemTier;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== materialComposition) {
    t16 = materialComposition?.trim() ? <FabricAdditionalAttributesTag>{materialComposition.trim()}</FabricAdditionalAttributesTag> : null;
    $[14] = materialComposition;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== selectedItemGroupCleaningCode || $[17] !== showCleaningToolTip) {
    t17 = selectedItemGroupCleaningCode && cleaningCodeDescriptions[selectedItemGroupCleaningCode] ? <FabricAdditionalAttributesTag isCleaningCode={true} ref={cleaningCodeRef}>{`Cleaning Code ${selectedItemGroupCleaningCode}`}{showCleaningToolTip ? <span className="mt-0 mx-0"><FabricAttributeTooltip title={cleaningCodeDescriptions[selectedItemGroupCleaningCode].title} description={cleaningCodeDescriptions[selectedItemGroupCleaningCode].description} parentRef={cleaningCodeRef} /></span> : null}</FabricAdditionalAttributesTag> : null;
    $[16] = selectedItemGroupCleaningCode;
    $[17] = showCleaningToolTip;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15 || $[24] !== t16 || $[25] !== t17) {
    t18 = <div className="w-full flex flex-row items-stretch flex-wrap">{t11}{t12}{t13}{t14}{t15}{t16}{t17}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  return t18;
};
FabricAdditionalAttributes.propTypes = {
  selectedItemGroupMaterial: PropTypes.string,
  selectedItemGroupCleaningCode: PropTypes.string,
  isPetAndKidFriendly: PropTypes.bool,
  isSustainable: PropTypes.bool,
  selectedItemTier: PropTypes.string,
  showCleaningToolTip: PropTypes.bool,
  isPantoneFabric: PropTypes.bool,
  materialComposition: PropTypes.string
};
export default FabricAdditionalAttributes;
function _temp(attribute) {
  return attribute;
}
function _temp2(attribute_0) {
  return <FabricAdditionalAttributesTag key={attribute_0}>{attribute_0 === "greenguard" ? "GREENGUARD gold" : attribute_0}</FabricAdditionalAttributesTag>;
}